import { CircularProgress, styled, Typography } from '@mui/material'
import UserMasonryLayout from '../../../components/layouts/UserMasonryLayout'
import { useSelector } from 'react-redux'
import React, { useCallback, useEffect, useState } from 'react'
import { Box } from '@mui/material'
import lightTheme from '../../../styles/theme/lightTheme'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import {
  faHome,
  faCircleCheck,
  faMapMarker,
  faEnvelope,
  faPhone,
  faPen,
  faCircleExclamation,
} from '@fortawesome/pro-regular-svg-icons'
import Api from '../../../services/api.service'
import { handlingErrors } from '../../../utils'
import { GedTable, OffreTable, BiBlockTable } from '../../../components/tables'
import moment from 'moment-timezone'
import {
  ChoiceOfferModal,
  EditDocuments,
  EditEvent,
  EditInfos,
  EditPasswordModal,
  PaymentModal,
  EditBesoinEntreprise,
} from '../../../components/modals'
import EditBesoin from '../../../components/modals/EditBesoin'
import { Slide, toast, ToastContainer } from 'react-toastify'
import EditList from '../../../components/modals/EditList'
import DeleteGeneralModal from '../../../components/modals/DeleteGeneralModal'
import {
  disponibilitesList2,
  disponibleSousList2,
  ROLE_CANDIDAT,
  ROLE_ENTREPRISE,
  SOFTSKILLS,
  tarif_utilisation,
  VALEURS,
} from '../../../data'
import EditResume from '../../../components/modals/EditResume'
import UserMasonryLayoutCompany from '../../../components/layouts/UserMasonryLayoutCompany'
import BesoinTable from '../../../components/tables/BesoinTable'
import DetailBesoinEntreprise from '../../../components/modals/DetailBesoinEntreprise'
import GedTabs from '../../../components/tables/GedTabs'
import { CustomButton, GradientButton, OutlineButton } from '../../../components/buttons'
import AddEvent from '../../../components/modals/AddEvent'
import { useTranslation } from 'react-i18next'
import AtelierTable from '../../../components/tables/AtelierTable'
import OffreEntrepriseTable from '../../../components/tables/OffreEntrepriseTable'
import { faCalendar } from '@fortawesome/pro-solid-svg-icons'
import EditDisponibilite from '../../../components/modals/EditDisponibilite'
import CandidatureTable from '../../../components/tables/CandidatureTable'
import DetailCandidature from '../../../components/modals/DetailCandidature'

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} disableShrink />
    </Box>
  )
}

const ProfilContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '32px',
  justifyContent: 'space-between',
  position: 'relative',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  borderRadius: '16px',
  padding: '24px',
  color: 'white',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
  },
}))

const BannerProfil = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: 48,
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 16px',
  borderRadius: '12px',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    transform: 'translateX(4px)',
  },
}))

const WrapperBanner = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '10px',
}))

const BannerProfilContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '10px',
}))

const TitleSection = styled(Typography)(({ theme }) => ({
  fontFamily: 'Century Gothic Bold',
  fontSize: 16,
  lineHeight: '140%',
  letterSpacing: '0.2px',
  color: 'white',
  textTransform: 'uppercase',
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
}))

const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const WrapperProfilText = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  rowGap: '12px',
  textAlign: 'center',
  padding: '16px 0',
}))

const IconContainer = styled(Box)(({ theme }) => ({
  width: 36,
  height: 36,
  border: '2px solid rgba(255, 255, 255, 0.3)',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(10px)',
  transition: 'all 0.3s ease',

  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    border: '2px solid rgba(255, 255, 255, 0.5)',
    transform: 'scale(1.1)',
  },

  '&:active': {
    transform: 'scale(0.95)',
  },
}))

const UserDashboard = () => {
  const { t, i18n } = useTranslation()
  let navigate = useNavigate()
  const userData = useSelector((state) => state.userAuth.user)
  if (!userData) {
    navigate('/')
  }
  const [open, setOpen] = useState(false)
  const [openCalendar, setOpenCalendar] = useState(false)
  const [openDoc, setOpenDoc] = useState(false)
  const [openBesoin, setOpenBesoin] = useState(false)
  const [openDetailBesoin, setOpenDetailBesoin] = useState(false)
  const [openDetailCandidature, setOpenDetailCandidature] = useState(false)
  const [openResume, setOpenResume] = useState(false)
  const [openValeurs, setOpenValeurs] = useState(false)
  const [openCompetences, setOpenCompetences] = useState(false)
  const [openCompetencesAnnexes, setOpenCompetencesAnnexes] = useState(false)
  const [openSoftskils, setOpenSoftskils] = useState(false)
  /* const [role, setRole] = useState(userData?.data.role) */
  const [type, setType] = useState(null)
  const [typeOffre, setTypeOffre] = useState('offer')
  const [loading, setLoading] = useState(false)
  const [user, setUser] = useState([])
  const [besoins, setBesoins] = useState([])
  const [candidatures, setCandidatures] = useState([])
  const [besoin, setBesoin] = useState([])
  const [candidature, setCandidature] = useState([])
  const [resume, setResume] = useState([])
  const [isFile, setIsFile] = useState([])
  const [dateRdv, setDateRdv] = useState([])
  const [dateRdvPasse, setDateRdvPasse] = useState([])
  const [dateRdvRelation, setDateRdvRelation] = useState([])
  const [dateRdvPasseRelation, setDateRdvPasseRelation] = useState([])
  const [progress, setProgress] = useState(0)

  const params = useParams()

  useEffect(() => {
    if (params.eventId) {
      fetchEventData(params.eventId)
    }
  }, [params.eventId])

  const fetchEventData = async (id) => {
    try {
      let result = await Api.calendar.detail(id)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        console.error('erreur')
      }

      if (handling.ok) {
        const res = handling.data
        handleOpenEvent(res)
        /* if (res.entreprise?.fonctions?.id)
          setFonctionSelect(res.entreprise?.fonctions?.titre) */
        //if (res.candidat?.poste) setPosteSelect(res.candidat?.poste)
      }
    } catch (error) {
      console.error(error)
    }
  }

  /* const [loadingRdv, setLoadingRdv] = useState(false) */

  const handleOpen = useCallback(() => setOpen(true), [])
  const handleClose = useCallback(() => {
    setOpen(false)
    //fetchData()
  }, [])
  const handleOpenCalendar = () => {
    setOpenCalendar(true)
  }
  const handleCloseCalendar = useCallback(() => {
    setOpenCalendar(false)
    //fetchData()
  }, [])
  const handleSave = useCallback(() => {
    fetchData()
    setOpenEvent(false)
    setOpen(false)
    setOpenDoc(false)
    setOpenBesoin(false)
    setOpenResume(false)
    setOpenSoftskils(false)
    setOpenCompetences(false)
    setOpenCompetencesAnnexes(false)
    setOpenValeurs(false)
    setOpenPayementOffre(false)
    setOpenAddEvent(false)
  }, [])

  const handleSaveDisponibilite = useCallback(() => {
    toast.success(t('successMessage.disponibiliteChanged'))
    setOpenCalendar(false)
    setTimeout(function () {
      fetchData()
    }, 1000)
  }, [])

  const handleOpenDoc = useCallback(() => setOpenDoc(true), [])
  const handleCloseDoc = useCallback(() => {
    setOpenDoc(false)
    //fetchData()
  }, [])
  const handleOpenBesoin = useCallback(() => {
    setOpenBesoin(true)
  }, [])
  const handleOpenBesoinEntreprise = useCallback(() => {
    navigate('/user/annonces/create')
  }, [])
  const handleCloseBesoin = useCallback(() => {
    setOpenBesoin(false)
  }, [])
  const handleCloseDetailBesoin = useCallback(() => {
    setOpenDetailBesoin(false)
  }, [])
  const handleCloseDetailCandidature = useCallback(() => {
    setOpenDetailCandidature(false)
  }, [])
  const handleSaveDetailCandidature = useCallback(() => {
    getCandidatures(userData?.data.id, pageCandidature, userData?.data.role)
    setOpenDetailCandidature(false)
  }, [])
  const handleOpenResume = useCallback(() => setOpenResume(true), [])
  const handleCloseResume = useCallback(() => {
    setOpenResume(false)
    //fetchData()
  }, [])
  const handleOpenCompetences = useCallback(() => setOpenCompetences(true), [])
  const handleCloseCompetences = useCallback(() => {
    setOpenCompetences(false)
    //fetchData()
  }, [])
  const handleOpenCompetencesAnnexes = useCallback(
    () => setOpenCompetencesAnnexes(true),
    []
  )
  const handleCloseCompetencesAnnexes = useCallback(() => {
    setOpenCompetencesAnnexes(false)
    //fetchData()
  }, [])
  const handleOpenValeurs = useCallback(() => setOpenValeurs(true), [])
  const handleCloseValeurs = useCallback(() => {
    setOpenValeurs(false)
    //fetchData()
  }, [])
  const handleOpenSoftskils = useCallback(() => setOpenSoftskils(true), [])
  const handleCloseSoftskils = useCallback(() => {
    setOpenSoftskils(false)
    //fetchData()
  }, [])

  const handleOpenAddEvent = useCallback(() => setOpenAddEvent(true), [])
  const handleOpenOffer = useCallback(() => setOpenOffre(true), [])
  const handleCloseOffer = useCallback(() => {
    setOpenOffre(false)
    //fetchData()
  }, [])
  const handlePayementOffre = useCallback((offre) => {
    setTypeOffre(
      userData?.data.role === ROLE_CANDIDAT ? 'offer' : 'offerEntreprise'
    )
    setOffreToPay(offre)
    setOpenPayementOffre(true)
  }, [])
  const handlePayementAtelier = useCallback((atelier) => {
    setTypeOffre('atelier')
    setOffreToPay(atelier)
    setOpenPayementOffre(true)
  }, [])

  const handleClosePayementOffre = () => {
    setOpenPayementOffre(false)
    //fetchData()
  }
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openDeleteBesoinModal, setOpenDeleteBesoinModal] = useState(false)
  const handleCloseDeleteModal = useCallback(
    () => setOpenDeleteModal(false),
    []
  )
  const handleConfirmDeleteModal = () => removeFile()
  const handleCloseDeleteBesoinModal = () => setOpenDeleteBesoinModal(false)
  const handleConfirmDeleteBesoinModal = () => removeBesoin()
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [fileDelete, setFileDelete] = useState()
  const [besoinDelete, setBesoinDelete] = useState()
  const [loadingBesoin, setLoadingBesoin] = useState(true)
  const [loadingCandidatures, setLoadingCandidatures] = useState(true)

  const [openPayementOffre, setOpenPayementOffre] = useState(false)
  const [offreToPay, setOffreToPay] = useState()
  const [openOffre, setOpenOffre] = useState(false)
  const [offres, setOffres] = useState([])
  const [companySubscriptions, setCompanySubscriptions] = useState([])
  const [offreSelect, setOffreSelect] = useState('')
  const [offresSelect, setOffresSelect] = useState([])
  /* const [loadingOffer, setLoadingOffer] = useState(true) */
  const [loadingButton, setLoadingButton] = useState(false)
  const { handleSubmit } = useForm({ mode: 'onBlur' })
  const [page, setPage] = useState(1)
  const [pageCandidature, setPageCandidature] = useState(1)
  const [count, setCount] = useState(0)
  const [countCandidatures, setCountCandidatures] = useState(0)

  /* const [dateRelation, setDateRelation] = useState([]) */
  const [openEvent, setOpenEvent] = useState(false)
  const [openAddEvent, setOpenAddEvent] = useState(false)
  const [event, setEvent] = useState({})

  const handleOpenEvent = useCallback((event) => {
    setEvent(event)
    setOpenEvent(true)
  }, [])
  const handleCloseEvent = useCallback(() => {
    setOpenEvent(false)
    //fetchData()
  }, [])

  const handleCloseAddEvent = useCallback(() => {
    setOpenAddEvent(false)
    //fetchData()
  }, [])

  const [openPasswordModal, setOpenPasswordModal] = useState(false)
  const handleOpenPassword = () => setOpenPasswordModal(true)
  const handleClosePassword = () => setOpenPasswordModal(false)

  const onSuccessChangePassword = () => {
    toast.success(t('successMessage.passwordChanged'), {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      icon: ({ theme, type }) => (
        <FontAwesomeIcon
          icon={faCircleCheck}
          fontSize={25}
          color={lightTheme.palette.success.main}
        />
      ),
    })
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    if (userData?.data.role === ROLE_CANDIDAT) {
      getOffers()
    }
    /*  if (userData?.data.role === ROLE_ENTREPRISE) {
      getCompanySubscriptions()
    } */
    fetchData()
    if (sessionStorage.getItem('offerSelected')) {
      setOffreSelect(JSON.parse(sessionStorage.getItem('offerSelected')))
      if (userData?.data.role === ROLE_CANDIDAT && offreSelect)
        addOffer(offreSelect)
    }
  }, [userData?.data.role])

  const handleSaveBesoin = () => {
    setOpenBesoin(false)
    getBesoinsCompany(user.entreprise?.id, page)
  }

  const handleSaveBesoinPublish = () => {
    setOpenBesoin(false)
    fetchData()
  }

  const getBesoinsCompany = async (idCompany, page) => {
    setLoadingBesoin(true)
    try {
      let result = await Api.besoinEntreprise.listWithFilter({
        entreprise: idCompany,
        page: page,
        itemsPerPage: 5,
      })

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        setLoadingBesoin(false)
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling
        setLoadingBesoin(false)
        setBesoins(res.data['hydra:member'])
        setCount(res.data['hydra:totalItems'])
      } else {
        setLoadingBesoin(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      setLoadingBesoin(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
    }
  }

  const getCompanySubscriptions = async () => {
    try {
      let result = await Api.companySubscriptions.listWithFilter({
        utilisateur: `/api/utilisateurs/${userData?.data.id}`,
      })

      setCompanySubscriptions(result)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        //setLoadingOffer(false)
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling.data
        //setLoadingOffer(false)
        setCompanySubscriptions(res)
      } else {
        //setLoadingOffer(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      //setLoadingOffer(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
    }
  }

  const getCandidatures = async (id, page, roleUser) => {
    setLoadingCandidatures(true)
    try {
      let result = await Api.candidature.listWithFilter({
        [roleUser === ROLE_CANDIDAT
          ? 'user'
          : 'besoinEntreprise.entreprise.profile']: id,
        page: page,
      })

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        setLoadingCandidatures(false)
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling
        setLoadingCandidatures(false)
        setCandidatures(res.data['hydra:member'])
        setCountCandidatures(res.data['hydra:totalItems'])
      } else {
        setLoadingCandidatures(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      setLoadingCandidatures(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
    }
  }

  const getOffers = async () => {
    try {
      let result = await Api.offer.listWithFilter({
        categorie:
          userData?.data.role === ROLE_ENTREPRISE ? 'entreprise' : 'candidat',
      })

      setOffres(result)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        //setLoadingOffer(false)
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
        return
      }

      if (handling.ok) {
        const res = handling.data
        //setLoadingOffer(false)
        setOffres(res)
      } else {
        //setLoadingOffer(false)
        window.scrollTo(0, 0)
      }
    } catch (error) {
      //setLoadingOffer(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
      window.scrollTo(0, 0)
    }
  }

  const handleChangeSelect = (evt) => {
    const inputValue = evt.target.value
    setOffreSelect(inputValue)
  }

  const addOffer = async (offer) => {
    if (sessionStorage.getItem('offerSelected')) {
      let offerUser = {
        offre: `/api/offres/${offer.id}`,
        prix: offer.prix,
        utilisateur: `/api/utilisateurs/${userData?.data.id}`,
      }
      if (userData?.data.role !== ROLE_CANDIDAT) {
        offerUser = {
          offre: `/api/offres_entreprises/${offer.id}`,
          prix: parseInt(
            offer[`prix${sessionStorage.getItem('periodeSelected')}`]
          ),
          prixPromo: parseInt(
            offer[`prix${sessionStorage.getItem('periodeSelected')}`]
          ),
          periode: parseInt(sessionStorage.getItem('periodeSelected')),
          utilisateur: `/api/utilisateurs/${userData?.data.id}`,
        }
      }

      try {
        const result = await Api.offerUtilisateur.add(
          offerUser,
          userData?.data.role
        )

        const handling = handlingErrors(result)

        if (handling.ok) {
          const res = handling.data
          //setSnapShot(res);
          handlePayementOffre(res)
          fetchData()
          sessionStorage.removeItem('offerSelected')
          sessionStorage.removeItem('periodeSelected')
          toast.success(
            t('successMessage.offerAdded') +
            '<br>' +
            t('successMessage.proceedPayment'),
            {
              position: 'top-right',
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
              icon: ({ theme, type }) => (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  fontSize={25}
                  color={lightTheme.palette.success.main}
                />
              ),
            }
          )
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  const onSubmit = async (data) => {
    setLoadingButton(true)

    offresSelect.push({
      offre: `/api/offres/${offreSelect.id}`,
      prix: offreSelect.prix,
    })
    setOffresSelect(offresSelect)

    try {
      const result = await Api.user.edit(userData?.data.id, {
        userOffres: userData?.data.role === ROLE_CANDIDAT ? offresSelect : [],
        entrepriseOffres:
          userData?.data.role !== ROLE_CANDIDAT ? offresSelect : [],
      })

      const handling = handlingErrors(result)

      if (handling.ok) {
        const res = handling.data
        //setSnapShot(res);
        setOpenOffre(false)
        setLoadingButton(false)
        handlePayementOffre(
          userData?.data.role === ROLE_CANDIDAT
            ? res.userOffres.slice(-1)[0]
            : res.entrepriseOffres.slice(-1)[0]
        )
        fetchData()
        toast.success(t('successMessage.offerAdded'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleCheck}
              fontSize={25}
              color={lightTheme.palette.success.main}
            />
          ),
        })
      }
    } catch (error) {
      setLoadingButton(false)
    }
  }

  const handleRemove = (idFile) => {
    setOpenDeleteModal(true)
    setFileDelete(idFile)
  }
  const handleEditBesoin = (besoin) => {
    setOpenBesoin(true)
    setBesoin(besoin)
  }
  const handleDetailBesoin = (besoin) => {
    setOpenDetailBesoin(true)
    setBesoin(besoin)
  }
  const handleDetailCandidature = (candidature) => {
    //navigate(`/offres-emploi/${candidature?.besoinEntreprise?.id}`)

    setOpenDetailCandidature(true)
    setCandidature(candidature)
  }
  const handleRemoveBesoin = (idBesoin) => {
    setOpenDeleteBesoinModal(true)
    setBesoinDelete(idBesoin)
  }
  const handlePageChange = (event, page) => {
    setPage(page)
    getBesoinsCompany(user.entreprise?.id, page)
  }
  const handlePageCandidatureChange = (event, page) => {
    setPageCandidature(page)
    getCandidatures(page)
  }
  const removeBesoin = async () => {
    setLoadingDelete(true)
    try {
      let result = await Api.besoinEntreprise.delete(besoinDelete)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        const indexBesoin = besoins.findIndex((bs) => bs.id === besoinDelete)

        if (indexBesoin > -1) {
          besoins.splice(indexBesoin, 1)
        }
        setBesoins(besoins)
        setOpenDeleteBesoinModal(false)
      } else {
        window.scrollTo(0, 0)
      }
    } catch (error) {
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
    }
    setLoadingDelete(false)
  }

  const handleCopyBesoin = async (besoin) => {
    setLoadingBesoin(true)
    try {
      let result = await Api.besoinEntreprise.copy(besoin.id)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error('Votre session à expiré, merci de vous reconnecter.', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        handleSaveBesoin()
      } else {
        setLoadingBesoin(false)
      }
    } catch (error) {
      setLoadingBesoin(false)
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
    }
  }

  const removeFile = async () => {
    setLoadingDelete(true)
    try {
      let result = await Api.document.delete(fileDelete)

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        toast.error(t('successMessage.sessionExpired'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
          icon: ({ theme, type }) => (
            <FontAwesomeIcon
              icon={faCircleExclamation}
              fontSize={25}
              color={lightTheme.palette.error.main}
            />
          ),
        })
        window.scrollTo(0, 0)
      }

      if (handling.ok) {
        const indexFile = isFile.findIndex((file) => file.id === fileDelete)

        if (indexFile > -1) {
          isFile.splice(indexFile, 1)
        }
        setIsFile(isFile)
        setOpenDeleteModal(false)
      } else {
        window.scrollTo(0, 0)
      }
    } catch (error) {
      toast.error(t('successMessage.somethingWrong'), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        icon: ({ theme, type }) => (
          <FontAwesomeIcon
            icon={faCircleExclamation}
            fontSize={25}
            color={lightTheme.palette.error.main}
          />
        ),
      })
    }
    setLoadingDelete(false)
  }

  const fetchData = async () => {
    setLoading(true)

    try {
      let result = await Api.user.detail(userData?.data.id)

      //setRole(result.data.role)

      if (userData?.data.role === ROLE_ENTREPRISE) {
        setType('entreprise')
      } else if (userData?.data.role === ROLE_CANDIDAT) {
        setType('candidat')
      } else {
        setType(null)
      }

      const handling = handlingErrors(result)

      if (handling.status === 401) {
        console.error('erreur')
      }

      if (handling.ok) {
        const res = handling.data
        setUser(res)
        if (userData?.data.role === ROLE_ENTREPRISE) {
          getBesoinsCompany(res.entreprise?.id, page)
          setCompanySubscriptions(res.companySubscriptions)
        }

        getCandidatures(userData?.data.id, pageCandidature, userData?.data.role)

        const currentDate = new Date()
        setDateRdv(
          userData?.data.role === ROLE_CANDIDAT
            ? res.candidat?.calendriers
              .filter((item) => currentDate < new Date(item.dateDebut))
              .sort((a, b) => a.id - b.id)
            : res.entreprise?.calendriers
              .filter((item) => currentDate < new Date(item.dateDebut))
              .sort((a, b) => a.id - b.id)
        )
        setDateRdvPasse(
          userData?.data.role === ROLE_CANDIDAT
            ? res.candidat?.calendriers
              .filter((item) => new Date(item.dateDebut) < currentDate)
              .sort((a, b) => a.id - b.id)
            : res.entreprise?.calendriers
              .filter((item) => new Date(item.dateDebut) < currentDate)
              .sort((a, b) => a.id - b.id)
        )

        if (userData?.data.role === ROLE_CANDIDAT) {
          setDateRdvRelation(
            res.candidat?.calendriers
              .filter(
                (item) =>
                  currentDate < new Date(item.dateDebut) &&
                  item.type === 'rdv_entreprise'
              )
              .sort((a, b) => a.id - b.id)
          )
          setDateRdvPasseRelation(
            res.candidat?.calendriers
              .filter(
                (item) =>
                  new Date(item.dateDebut) < currentDate &&
                  item.type === 'rdv_entreprise'
              )
              .sort((a, b) => a.id - b.id)
          )
        }

        let userOffres = []
        if (userData?.data.role === ROLE_CANDIDAT && res.userOffres) {
          res.userOffres.map((userOffre, i) => {
            userOffres.push({
              id: userOffre.id,
              offre: `/api/offres/${userOffre.offre.id}`,
              prix: userOffre.prix,
            })
          })
        }
        if (userData?.data.role !== ROLE_CANDIDAT && res.entrepriseOffres) {
          res.entrepriseOffres.map((userOffre, i) => {
            userOffres.push({
              id: userOffre.id,
              offre: `/api/offres_entreprises/${userOffre.offre.id}`,
              prix: userOffre.prix,
            })
          })
        }
        setOffresSelect(userOffres)
        let docs = []
        //if (res.candidat?.cv) docs.push({ type: 'cv', nom: res.candidat?.cv })
        if (res.documents) {
          const documents = Object.values(res.documents)
          documents.forEach((doc) => {
            docs.push(doc)
          })
        }

        setIsFile(docs)
        if (userData?.data.role === ROLE_CANDIDAT)
          setBesoin(res.candidat?.besoin)

        setResume(
          userData?.data.role === ROLE_CANDIDAT ? res.candidat?.resume : ''
        )

        let totalProfil = 0
        if (userData?.data.role === ROLE_CANDIDAT) {
          if (res.candidat?.besoin) totalProfil = totalProfil + 10
          if (res.candidat?.resume) totalProfil = totalProfil + 10
          if (res.userLangues.length > 0) totalProfil = totalProfil + 10
          if (res.candidat?.competences.length > 0)
            totalProfil = totalProfil + 10
          if (res.candidat?.softskils.length > 0) totalProfil = totalProfil + 10
          if (res.candidat?.valeurs.length > 0) totalProfil = totalProfil + 10
          if (
            Object.keys(res.documents)
              .map((key) => res.documents[key])
              .find((item) => item.type === 'Cv')
          )
            totalProfil = totalProfil + 40

          setProgress(totalProfil)
        }

        setLoading(false)

        if (!userData?.data.autorise) {
          toast.error(t('successMessage.notAuthorized'), {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
            icon: ({ theme, type }) => (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                fontSize={25}
                color={lightTheme.palette.error.main}
              />
            ),
          })
          navigate(
            userData?.data.role === ROLE_CANDIDAT
              ? '/candidats'
              : '/entreprises/offres'
          )
        }
      }
    } catch (error) {
      console.error(error)
      setLoading(false)
    }
  }

  if (!type && loading)
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    )

  if (type === 'entreprise')
    return (
      <>
        <UserMasonryLayoutCompany
          user={userData}
          type={type}
          handleOpenDoc={handleOpenDoc}
          handleOpenBesoin={handleOpenBesoinEntreprise}
          handleOpenResume={handleOpenResume}
          handleOpenValeurs={handleOpenValeurs}
          handleOpenCompetences={handleOpenCompetences}
          handleOpenCompetencesAnnexes={handleOpenCompetencesAnnexes}
          handleOpenSoftskils={handleOpenSoftskils}
          handleOpenOffer={handleOpenOffer}
          profil={
            <ProfilContainer>
              <TitleContainer>
                <TitleSection>{t('profile.title')}</TitleSection>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 'auto',
                  }}
                >
                  <IconContainer
                    sx={{ marginRight: '5px' }}
                    onClick={handleOpen}
                  >
                    <FontAwesomeIcon
                      icon={faPen}
                      fontSize={15}
                      color={lightTheme.palette.primary.b2}
                    />
                  </IconContainer>
                  <IconContainer onClick={handleOpenCalendar}>
                    <FontAwesomeIcon
                      icon={faCalendar}
                      fontSize={15}
                      color={lightTheme.palette.primary.b2}
                    />
                  </IconContainer>
                </Box>
              </TitleContainer>
              <WrapperProfilText>
                <Typography
                  sx={{
                    fontFamily: 'Century Gothic Bold',
                    fontSize: { xs: 20 },
                    lineHeight: '120%',
                    color: 'white',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                  }}
                >
                  {user.entreprise?.raisonSocial}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 16 },
                    textAlign: 'center',
                    color: 'white',
                    textTransform: 'capitalize',
                  }}
                >
                  {user.prenom} {user.nom}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 14 },
                    textAlign: 'center',
                    color: 'white',
                  }}
                >
                  {user.entreprise?.fonctions?.titre}
                  {user.candidat?.poste?.titre}
                </Typography>
              </WrapperProfilText>
              <BannerProfilContainer>
                <WrapperBanner>
                  {/* {user.langues?.length > 0 && (
                <BannerProfil>
                  <FontAwesomeIcon icon={faComment} />
                  <Typography>{user.langues}</Typography>
                </BannerProfil>
              )} */}
                  <BannerProfil>
                    <FontAwesomeIcon icon={faMapMarker} />

                    <Typography
                      textAlign={'right'}
                      title={user.adresse}
                      color={'white'}
                      style={{
                        width: '90%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        lineHeight: '16px',
                      }}
                    >
                      {user.adresse}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon icon={faHome} />
                    <Typography color={'white'}>
                      {user.codePostal} / {user.ville} / {user.pays}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <Typography
                      color={'white'}
                      textAlign={'right'}
                      title={user.email}
                      style={{
                        width: '90%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                    >
                      {user.email}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon icon={faPhone} />
                    <Typography color={'white'}>{user.telephone}</Typography>
                  </BannerProfil>

                  {false ? (
                    <CircularProgress />
                  ) : (
                    <OutlineButton
                      displayIcon={'none'}
                      onClick={() => setOpenAddEvent(true)}
                      sx={{
                        color: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.35)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.55)',
                        }
                      }}
                    >
                      {t('profile.appointmentRequest')}
                    </OutlineButton>
                  )}
                </WrapperBanner>
                {/*<BorderButtonPurple>Voir le résumé</BorderButtonPurple>*/}
              </BannerProfilContainer>
            </ProfilContainer>
          }
          besoinClient={
            besoins && (
              <BesoinTable
                besoins={besoins}
                loading={loadingBesoin}
                handleRemove={handleRemoveBesoin}
                handleEdit={handleEditBesoin}
                handleCopy={handleCopyBesoin}
                handleDetailBesoin={handleDetailBesoin}
                handlePageChange={handlePageChange}
                count={count}
                page={page}
                role={userData?.data.role}
                userData={userData?.data}
                pageSize={5}
              />
            )
          }
          candidatures={
            candidatures && (
              <CandidatureTable
                candidatures={candidatures}
                loading={loadingCandidatures}
                handleDetailCandidature={handleDetailCandidature}
                handlePageChange={handlePageCandidatureChange}
                count={countCandidatures}
                page={pageCandidature}
                userData={userData?.data}
              />
            )
          }
          resumeClient={
            <Typography variant={'body2'} color={lightTheme.palette.grey.grey}>
              <div style={{ whiteSpace: 'pre-line' }}>{resume}</div>
            </Typography>
          }
          offre={
            companySubscriptions && (
              <OffreEntrepriseTable
                offres={companySubscriptions}
                handlePayementOffre={handlePayementOffre}
              />
            )
          }
          atelier={
            user.userAteliers && (
              <AtelierTable
                ateliers={user.userAteliers}
                handlePayementAtelier={handlePayementAtelier}
              />
            )
          }
          ged={
            isFile ? (
              <GedTable
                files={isFile}
                dateFile={moment(user.date)
                  .tz('Europe/Paris')
                  .format('DD/MM/YYYY HH:mm')}
                handleRemove={handleRemove}
              />
            ) : (
              <GedTable />
            )
          }
          rendezVous={
            <BiBlockTable
              rdvAVenir={dateRdv}
              rdvPasse={dateRdvPasse}
              heureAVenir={''}
              handleOpenEvent={handleOpenEvent}
              type={type}
            />
          }
          relation={<BiBlockTable rdvAVenir={[]} heureAVenir={''} />}
          displayValeurSection={'display'}
          valeurs={user.entreprise?.valeurs}
          loading={loading}
        />
        {open && (
          <EditInfos
            open={open}
            onClose={handleClose}
            onSave={handleSave}
            handleOpenPassword={handleOpenPassword}
            id={userData?.data.id}
            role={userData?.data.role}
            type={userData?.data.role}
          />
        )}
        {openBesoin && (
          <EditBesoin
            open={openBesoin}
            onClose={handleCloseBesoin}
            onSave={handleSave}
            id={userData?.data.id}
            besoin={besoin}
          />
        )}
        {openResume && (
          <EditResume
            open={openResume}
            onClose={handleCloseResume}
            onSave={handleSave}
            id={userData?.data.id}
          />
        )}
        {openDoc && (
          <EditDocuments
            open={openDoc}
            onClose={handleCloseDoc}
            onSave={handleSave}
            id={userData?.data.id}
            isAdmin={false}
            role={userData?.data.role}
          />
        )}
        {openPasswordModal && (
          <EditPasswordModal
            open={openPasswordModal}
            onClose={handleClosePassword}
            id={userData?.data.id}
            onSuccess={onSuccessChangePassword}
          />
        )}
        {openBesoin && (
          <EditBesoinEntreprise
            open={openBesoin}
            onClose={handleCloseBesoin}
            onSave={handleSaveBesoin}
            onSavePublish={handleSaveBesoinPublish}
            id={user.entreprise?.id}
            besoin={besoin}
            role={userData?.data.role}
            entrepriseOffres={user.entrepriseOffres.filter(
              (entrepriseOffre) =>
                entrepriseOffre.status === 'payer' &&
                entrepriseOffre.credit > 0 &&
                entrepriseOffre.offre.type === tarif_utilisation
            )}
          />
        )}
        {openDetailBesoin && (
          <DetailBesoinEntreprise
            open={openDetailBesoin}
            onClose={handleCloseDetailBesoin}
            besoin={besoin}
            role={userData?.data.role}
            toast={toast}
          />
        )}
        {openDetailCandidature && (
          <DetailCandidature
            open={openDetailCandidature}
            onClose={handleCloseDetailCandidature}
            onSave={handleSaveDetailCandidature}
            candidature={candidature}
            role={userData?.data.role}
            toast={toast}
          />
        )}
        {openOffre && (
          <ChoiceOfferModal
            open={openOffre}
            onClose={handleCloseOffer}
            items={offres}
            handleClick={handleSubmit(onSubmit)}
            value={offreSelect}
            handleChange={handleChangeSelect}
            loading={loadingButton}
            role={userData?.data.role}
            type={'entreprise'}
          />
        )}
        {openPayementOffre && (
          <PaymentModal
            open={openPayementOffre}
            onClose={handleClosePayementOffre}
            userId={userData?.data.id}
            userOffre={offreToPay}
            typeOffre={typeOffre}
            currency={'eur'}
            role={userData?.data.role}
            onSuccess={handleSave}
          />
        )}
        {openDeleteModal && (
          <DeleteGeneralModal
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}
            onConfirm={handleConfirmDeleteModal}
            loading={loadingDelete}
          />
        )}
        {openDeleteBesoinModal && (
          <DeleteGeneralModal
            open={openDeleteBesoinModal}
            onClose={handleCloseDeleteBesoinModal}
            onConfirm={handleConfirmDeleteBesoinModal}
            loading={loadingDelete}
          />
        )}
        {openEvent && (
          <EditEvent
            open={openEvent}
            onClose={handleCloseEvent}
            id={userData?.data.id}
            role={userData?.data.role}
            event={event}
            poste={event.candidat?.poste?.titre}
            onSave={handleSave}
            showParams={false}
          />
        )}
        {openValeurs && (
          <EditList
            open={openValeurs}
            onClose={handleCloseValeurs}
            onSave={handleSave}
            id={user.entreprise?.id}
            type={'valeurs'}
            values={user.entreprise?.valeurs}
            /* datas={VALEURS[i18n.language]} */
            datas={[...VALEURS['fr'], ...VALEURS['en']]}
            role={'entreprise'}
          />
        )}
        {openAddEvent && (
          <AddEvent
            open={openAddEvent}
            onClose={handleCloseAddEvent}
            id={user.entreprise?.id}
            role={userData?.data.role}
            onSave={handleSave}
          />
        )}
        {openCalendar && (
          <EditDisponibilite
            open={openCalendar}
            onClose={handleCloseCalendar}
            onSave={handleSaveDisponibilite}
            user={user}
          />
        )}

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          closeButton={false}
          transition={Slide}
          className={'toast'}
        />
      </>
    )
  if (type === 'candidat')
    return (
      <>
        <UserMasonryLayout
          user={userData}
          userLangues={user.userLangues}
          type={type}
          handleOpenDoc={handleOpenDoc}
          handleOpenBesoin={handleOpenBesoin}
          handleOpenResume={handleOpenResume}
          handleOpenValeurs={handleOpenValeurs}
          handleOpenCompetences={handleOpenCompetences}
          handleOpenCompetencesAnnexes={handleOpenCompetencesAnnexes}
          handleOpenSoftskils={handleOpenSoftskils}
          handleOpenOffer={handleOpenOffer}
          handleOpenAddEvent={handleOpenAddEvent}
          profil={
            <ProfilContainer>
              <TitleContainer>
                <TitleSection
                  sx={{
                    color:
                      user.userLangues.length === 0
                        ? lightTheme.palette.error.main
                        : 'white',
                  }}
                >
                  {t('profile.title')}
                  {user.userLangues.length === 0 && '*'}
                </TitleSection>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 'auto',
                  }}
                >
                  <IconContainer onClick={handleOpen}>
                    <FontAwesomeIcon
                      icon={faPen}
                      fontSize={15}
                      color={lightTheme.palette.primary.b2}
                    />
                  </IconContainer>
                </Box>
              </TitleContainer>
              <WrapperProfilText>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      display: 'inline-flex',
                    }}
                  >
                    <CircularProgressWithLabel
                      value={progress}
                      color={progress > 50 ? 'success' : 'warning'}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                        }}
                      >
                        {`${Math.round(progress)}%`}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Typography
                  variant={'h5'}
                  textAlign={'center'}
                  textTransform={'capitalize'}
                  sx={{
                    color: 'white',
                    fontWeight: 'bold',
                    fontSize: '24px',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  }}
                >
                  {user.prenom} {user.nom}
                </Typography>
                <Typography
                  variant={'body1'}
                  sx={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    textAlign: 'center',
                    fontSize: '16px',
                  }}
                >
                  {user.entreprise?.fonctions?.titre}
                  {user.candidat?.poste?.titre}
                </Typography>

                {user.candidat?.typeDisponibilite && (
                  <Typography
                    variant={'body2'}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.8)',
                      textAlign: 'center',
                      fontSize: '14px',
                      fontStyle: 'italic',
                    }}
                  >
                    {
                      disponibilitesList2.find(
                        (dispo) => dispo.id === user.candidat?.typeDisponibilite
                      ).titre[i18n.language]
                    }

                    {user.candidat?.typeDisponibilite === 2 &&
                      user.candidat?.disponibleSous &&
                      disponibleSousList2.find(
                        (dispoS) => dispoS.id === user.candidat?.disponibleSous
                      ).titre[i18n.language]}

                    {user.candidat?.typeDisponibilite === 4 &&
                      moment(user.candidat?.disponible)
                        .tz('Europe/Paris')
                        .format('DD/MM/YYYY')}
                  </Typography>
                )}
              </WrapperProfilText>
              <BannerProfilContainer>
                <WrapperBanner>
                  {/* {user.langues?.length > 0 && (
                  <BannerProfil>
                    <FontAwesomeIcon icon={faComment} />
                    <Typography>{user.langues}</Typography>
                  </BannerProfil>
                )} */}
                  <BannerProfil>
                    <FontAwesomeIcon
                      icon={faMapMarker}
                      style={{ color: 'white', fontSize: '16px' }}
                    />

                    <Typography
                      textAlign={'right'}
                      title={user.adresse}
                      sx={{
                        width: '90%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        lineHeight: '16px',
                        color: 'white',
                        fontSize: '14px',
                      }}
                    >
                      {user.adresse}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon
                      icon={faHome}
                      style={{ color: 'white', fontSize: '16px' }}
                    />
                    <Typography sx={{ color: 'white', fontSize: '14px' }}>
                      {user.codePostal} / {user.ville} / {user.pays}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: 'white', fontSize: '16px' }}
                    />
                    <Typography
                      textAlign={'right'}
                      title={user.email}
                      sx={{
                        width: '90%',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        color: 'white',
                        fontSize: '14px',
                      }}
                    >
                      {user.email}
                    </Typography>
                  </BannerProfil>
                  <BannerProfil>
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: 'white', fontSize: '16px' }}
                    />
                    <Typography sx={{ color: 'white', fontSize: '14px' }}>
                      {user.telephone}
                    </Typography>
                  </BannerProfil>
                  {/*   {user.dateNaissance && (
                  <BannerProfil>
                    <FontAwesomeIcon icon={faCakeCandles} />
                    <Typography>{user.dateNaissance}</Typography>
                  </BannerProfil>
                )} */}

                  {/* {user.statusMarital && (
                  <BannerProfil>
                    <FontAwesomeIcon icon={faRingsWedding} />
                    <Typography>{user.statusMarital}</Typography>
                  </BannerProfil>
                )} */}

                  {false ? (
                    <CircularProgress />
                  ) : (
                    <OutlineButton
                      displayIcon={'none'}
                      onClick={() => setOpenAddEvent(true)}
                      sx={{
                        color: 'white',
                        backgroundColor: 'rgba(255, 255, 255, 0.35)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.55)',
                        }
                      }}
                    >
                      {t('profile.appointmentRequest')}
                    </OutlineButton>
                  )}
                </WrapperBanner>
                {/*<BorderButtonPurple>Voir le résumé</BorderButtonPurple>*/}
              </BannerProfilContainer>
            </ProfilContainer>
          }
          besoin={besoin}
          candidatures={
            candidatures && (
              <CandidatureTable
                candidatures={candidatures}
                loading={loadingCandidatures}
                handleDetailCandidature={handleDetailCandidature}
                handlePageChange={handlePageCandidatureChange}
                count={countCandidatures}
                page={pageCandidature}
                userData={userData?.data}
              />
            )
          }
          besoinClient={
            <Typography variant={'body2'} color={lightTheme.palette.grey.grey}>
              <div style={{ whiteSpace: 'pre-line' }}>{besoin}</div>
            </Typography>
          }
          resume={resume}
          resumeClient={
            <Typography variant={'body2'} color={lightTheme.palette.grey.grey}>
              <div style={{ whiteSpace: 'pre-line' }}>{resume}</div>
            </Typography>
          }
          offre={
            user.userOffres && (
              <OffreTable
                offres={user.userOffres}
                handlePayementOffre={handlePayementOffre}
              />
            )
          }
          atelier={
            user.userAteliers && (
              <AtelierTable
                ateliers={user.userAteliers}
                handlePayementAtelier={handlePayementAtelier}
              />
            )
          }
          files={isFile}
          ged={
            isFile ? (
              <GedTabs
                files={isFile}
                dateFile={moment(user.date)
                  .tz('Europe/Paris')
                  .format('DD/MM/YYYY HH:mm')}
                handleRemove={handleRemove}
              />
            ) : (
              <GedTable />
            )
          }
          rendezVous={
            <BiBlockTable
              rdvAVenir={dateRdv}
              rdvPasse={dateRdvPasse}
              heureAVenir={''}
              handleOpenEvent={handleOpenEvent}
              type={type}
            />
          }
          relation={
            <BiBlockTable
              rdvAVenir={dateRdvRelation}
              rdvPasse={dateRdvPasseRelation}
              heureAVenir={''}
              handleOpenEvent={handleOpenEvent}
            />
          }
          /*  displayValeurSection={type === 'entreprise' ? 'bloc' : 'none'}
        valeurs={
          <ValeurContainer>
            {role === ROLE_ENTREPRISE && (
              <Typography>{user.entreprise.valeurs}</Typography>
            )}
          </ValeurContainer>
        } */

          displayCompetencesSection={
            userData?.data.role === ROLE_CANDIDAT ? 'display' : 'none'
          }
          competences={user.candidat?.competences}
          competencesAnnexes={user.candidat?.competencesAnnexes}
          displaySoftskilSection={
            userData?.data.role === ROLE_CANDIDAT ? 'display' : 'none'
          }
          softskils={user.candidat?.softskils}
          displayValeurSection={
            userData?.data.role === ROLE_CANDIDAT ? 'display' : 'none'
          }
          valeurs={user.candidat?.valeurs}
          loading={loading}
        />
        {open && (
          <EditInfos
            open={open}
            onClose={handleClose}
            onSave={handleSave}
            handleOpenPassword={handleOpenPassword}
            id={userData?.data.id}
            role={userData?.data.role}
            type={userData?.data.role}
          />
        )}
        {openBesoin && (
          <EditBesoin
            open={openBesoin}
            onClose={handleCloseBesoin}
            onSave={handleSave}
            id={userData?.data.id}
          />
        )}
        {openResume && (
          <EditResume
            open={openResume}
            onClose={handleCloseResume}
            onSave={handleSave}
            id={userData?.data.id}
          />
        )}
        {openDoc && (
          <EditDocuments
            open={openDoc}
            onClose={handleCloseDoc}
            onSave={handleSave}
            id={userData?.data.id}
            isAdmin={false}
            role={userData?.data.role}
          />
        )}
        {openPasswordModal && (
          <EditPasswordModal
            open={openPasswordModal}
            onClose={handleClosePassword}
            id={userData?.data.id}
            onSuccess={onSuccessChangePassword}
          />
        )}
        {userData?.data.role === ROLE_CANDIDAT && openCompetences && (
          <EditList
            open={openCompetences}
            onClose={handleCloseCompetences}
            onSave={handleSave}
            id={user.candidat?.id}
            type={'competences'}
            values={user.candidat?.competences}
            datas={[]}
          />
        )}
        {userData?.data.role === ROLE_CANDIDAT && openCompetencesAnnexes && (
          <EditList
            open={openCompetencesAnnexes}
            onClose={handleCloseCompetencesAnnexes}
            onSave={handleSave}
            id={user.candidat?.id}
            type={'competencesAnnexes'}
            values={user.candidat?.competencesAnnexes}
            datas={[]}
          />
        )}
        {userData?.data.role === ROLE_CANDIDAT && openSoftskils && (
          <EditList
            open={openSoftskils}
            onClose={handleCloseSoftskils}
            onSave={handleSave}
            id={user.candidat?.id}
            type={'softskils'}
            values={user.candidat?.softskils}
            datas={[...SOFTSKILLS['fr'], ...SOFTSKILLS['en']].sort()}
          />
        )}
        {userData?.data.role === ROLE_CANDIDAT && openValeurs && (
          <EditList
            open={openValeurs}
            onClose={handleCloseValeurs}
            onSave={handleSave}
            id={user.candidat?.id}
            type={'valeurs'}
            values={user.candidat?.valeurs}
            datas={VALEURS[i18n.language]}
          />
        )}

        {openOffre && (
          <ChoiceOfferModal
            open={openOffre}
            onClose={handleCloseOffer}
            items={offres}
            handleClick={handleSubmit(onSubmit)}
            value={offreSelect}
            handleChange={handleChangeSelect}
            loading={loadingButton}
            role={userData?.data.role}
            type={'candidat'}
          />
        )}
        {openDetailCandidature && (
          <DetailCandidature
            open={openDetailCandidature}
            onClose={handleCloseDetailCandidature}
            onSave={handleSaveDetailCandidature}
            candidature={candidature}
            role={userData?.data.role}
            toast={toast}
          />
        )}
        {openPayementOffre && (
          <PaymentModal
            open={openPayementOffre}
            onClose={handleClosePayementOffre}
            userId={userData?.data.id}
            userOffre={offreToPay}
            typeOffre={typeOffre}
            currency={'eur'}
            role={userData?.data.role}
            onSuccess={handleSave}
          />
        )}

        {openDeleteModal && (
          <DeleteGeneralModal
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}
            onConfirm={handleConfirmDeleteModal}
            loading={loadingDelete}
          />
        )}

        {openEvent && (
          <EditEvent
            open={openEvent}
            onClose={handleCloseEvent}
            id={userData?.data.id}
            role={userData?.data.role}
            poste={user.candidat?.poste?.titre}
            event={event}
            onSave={handleSave}
            showParams={false}
          />
        )}

        {openAddEvent && (
          <AddEvent
            open={openAddEvent}
            onClose={handleCloseAddEvent}
            id={user.candidat?.id}
            role={userData?.data.role}
            onSave={handleSave}
          />
        )}

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          closeButton={false}
          transition={Slide}
          className={'toast'}
        />
      </>
    )
}

export default UserDashboard
